import React, { useEffect, useRef,useCallback, useState } from 'react'
import general from '../../general'
import Dialog from '../../lib/Dialog'
import { NavLink } from '../../lib/Navigation'
import './css/Chat.css'
import { useLocalStorageState } from 'ahooks'
import useActiveState from '../../lib/useActiveState'
import {useLockFn} from "ahooks";

export default function ChatSearch(props) {

  const [data, setData] = useState([])
  const [searchList, setSearchList] = useState([])
  const [chatSearchHistory, setChatSearchHistory] = useLocalStorageState('chat-search', [])
  const inputRef = useRef()
  const [user,setUser] = useActiveState('user')
  const [config] = useActiveState('config')
  const [isCheckAuth, setIsCheckAuth] = useState(false); //实名认证弹框状态
  const [authData, setAuthData] = useState({}); //实名认证参数值

  const certifiy = useLockFn(()=>{
    if(!authData.real_name) {
      Dialog.info('请输入姓名');
      return;
    }
    if(!authData.identity_card){
      Dialog.info('请输入身份证号');
      return;
    }
    Dialog.loading();
    general.axios.post('/user/user/editMemberInfo', {real_name:authData.real_name, identity_card:authData.identity_card})
      .finally(() => {
        Dialog.close();
      })
      .then(res => {
        let {status, data} = res.data;
        
        if (!status.succeed) {
          Dialog.info(status.error_desc);
        } else {
          Dialog.info("认证成功");
          setIsCheckAuth(false);
          // setUser({...user, isRealNameAuth: true});
          setUser({...user, ...{real_name: authData.real_name, identity_card: authData.identity_card, isRealNameAuth: true, isAdult: data.isAdult}});
        }
      })
      .catch(err => {
        Dialog.error(err.message);
      });
    })
    
  let isOnComposition = false;
  const [kw, setKw] = useState('');
  const [inputText, setInputText] = useState('');

  useEffect(() => {
    if (kw){
      search(kw)
    }
  },[kw])

  const handleComposition = (e) => {
    //中文输入状态
    if (e.type === 'compositionend') {
      isOnComposition = false;
      setInputText(e.target.value);
      setKw(e.target.value);
      return;
    } else if (e.type === 'compositionstart') {
      isOnComposition = true;
      return;
    } else if (e.type === 'compositionupdate') {
      isOnComposition = true;
      return;
    }
    isOnComposition = true;
  }

  const handleChange = (e) => {
    setInputText(e.target.value);
    if (!isOnComposition) {
      setKw(e.target.value);
    }

  }

  useEffect(() => {
    props.setTitle(<div style={{ display: 'flex', alignItems: 'center', backgroundColor: '#f3f3f3', padding: '7px 10px', borderRadius: '17px' }}>
      <img src="/resources/user/ss.png" alt="" height={14} />
      <input
        ref={inputRef}
        type="text"
        onCompositionStart = {handleComposition}
        onCompositionUpdate = {handleComposition}
        onCompositionEnd = {handleComposition}
        onChange = {handleChange}
        placeholder='请输入游戏名称搜索群聊'
        style={{ paddingLeft: '5px', border: 'none', fontSize: '13px', backgroundColor: 'transparent',flex:'1' }} />
    </div>)
    props.setOperate(<div className='chat-search-btn' onClick={() => {
      if (inputRef.current.value.length > 0){
        addHistory(inputRef.current.value)
      }
      search(inputRef.current.value)
    }}>搜索</div>)
  }, [])

  const search = (e) => {
    inputRef.current.value = e.trim()
    general.axios.post('/base/yunxin/getSearchClusters', {
      search_info: e,
      pagination: {
        count: 9999,
        page: 1
      }
    }).then(res => {
      const { status, data } = res.data
      if (status.succeed) {
        setSearchList(data.list)
        if (data.list.length == 0){
          Dialog.info('暂无此游戏')
        }
      } else {
        Dialog.error(status.error_desc)
      }
    })
  }

  const addHistory = (str)=>{
    setChatSearchHistory((prevHistory) => {
      return [str, ...prevHistory.filter(item => item !== str)];
    });
  }

  const getHotGameCluster = () => {
    general.axios.post('/base/yunxin/getHotGameCluster', { source: 'sousuo' })
      .then(res => {
        const { status, data } = res.data
        if (status.succeed) {
          setData(data.hot_game_cluster)
        } else {
          Dialog.error(status.error_desc)
        }
      })
  }

  useEffect(() => {
    getHotGameCluster()
  }, [])

  const join = (item) => {
    if (!item.is_open_cluster){
      return
    }
    if (user.isCheckAuth && !user.isRealNameAuth){
      setIsCheckAuth(true)
      return
    }
    general.axios.post('/base/yunxin/joinTeams', { topic_id: item.topic_id })
      .then(res => {
        const { data, status } = res.data
        if (status.succeed) {
          const { tid } = data.info
          if (localStorage.getItem('yx_login')) {
            general.history.push(`/chat?tid=${tid}`)
          } else {
            PubSub.publish('loginSubscribe', true)
            setTimeout(() => {
              general.history.push(`/chat?tid=${tid}`)
            }, 2000)
          }
        } else {
          Dialog.error(status.error_desc)
        }
      })
  }

  return (
    <div className='chat-search-index'>
      <div>
        {chatSearchHistory.length > 0 && <div className="header">
          <span>搜索历史</span>
          <img src="/resources/search/history_unset.png" alt="" height={17} onClick={() => {
            setChatSearchHistory([])
          }} />
        </div>}
        {chatSearchHistory.length > 0 && <div className="history">
          {chatSearchHistory.map(item => {
            return (
              <div className='item' onClick={() => {
                search(item)
              }}>{item}</div>
            )
          })}
        </div>}
        <div className="header">热门群聊</div>
        <div className="chats">
          {data.map((item) => {
            return (
              <div className='item' key={item.id}>
                <div className='imgs'>
                  <img className='icon' src={item.icon} alt="" />
                  <img className='tip' src={'resources/250410/hot.png'} alt="" />
                </div>
                <div className="name">{item.tname}</div>
                <NavLink onClick={() => join(item)} className="join">{item.is_join_cluster ? '进群' : '加群'}</NavLink>
              </div>
            )
          })}
        </div>
      </div>
      {searchList.length > 0 && <div className='chats search-result'>
        {searchList.map((item) => {
          return (
            <div className='item' key={item.tid}>
              <div className='imgs'>
                <img className='icon' src={item.icon} alt="" />
                <img className='tip' src={'resources/250410/guan.png'} alt="" />
              </div>
              <div className="name">{item.tname}</div>
              <NavLink onClick={() => join(item)} className={item.is_open_cluster ? 'join' : ''}>{item.is_open_cluster ? (item.is_join_cluster ? '进群' : '加群') : '暂未开放'}</NavLink>
            </div>
          )
        })}
        {searchList.length === 0 && inputRef.current?.value?.length > 0 ? <div className="empty"><img src="/resources/empty.png" alt=""/>暂无数据</div> : null}
        </div>}
        {isCheckAuth?
        <div className="pay-check-auth">
          <div className="auth-index">
            <div className="close" onClick={() => setIsCheckAuth(false)}>
              <img src="/resources/user/close.png" />
            </div>
            <div className="title">
              <div className="title-img">
                <img src="/resources/user/auth-title.png" />
              </div>
              <div>
                <h3>实名认证</h3>
                <p>
                {config.authTopTips}
                  {/* 根据国家新闻出版署最新规定，游戏用户需要进行实名认证，否则我们无法为您提供游戏及支付服务！ */}
                </p>
              </div>
            </div>

            <div className="auth-user-realname">
              <div className="auth-user-input">
                <div className="name">真实姓名</div>
                <input name="nick_name" type="text" placeholder="请输入姓名" autoComplete="off" value={authData.real_name} onChange={e => setAuthData({...authData, real_name: e.target.value})} />
              </div>
              <div className="auth-user-input">
                <div className="name">身份证号</div>
                <input name="number" type="text" placeholder="请输入身份证号" autoComplete="off" value={authData.identity_card} onChange={e => setAuthData({...authData, identity_card: e.target.value})} />
              </div>
              <span>
              {config.authBottomTips}
              {/* 您所提交的身份信息仅用于国家认证，我们将按照国家隐私条例严格保密信息，感谢您的支持！ */}
              </span>
              <div className="auth-user-btn" onClick={certifiy}>立即认证</div>
            </div>
          </div>
        </div> : null
      }
    </div>
  )
}
